export const DEFAULT_LANGUAGES = [
  "en-US",
  "en-IN",
  "en-GB",
  "en-AU",
  "en-NZ",
  "de-DE",
  "es-ES",
  "es-419",
  "hi-IN",
  "fr-FR",
  "fr-CA",
  "ja-JP",
  "pt-PT",
  "pt-BR",
  "zh-CN",
  "ru-RU",
  "it-IT",
  "ko-KR",
  "nl-NL",
  "nl-BE",
  "pl-PL",
  "tr-TR",
  "vi-VN",
  "ro-RO",
  "bg-BG",
  "ca-ES",
  "th-TH",
  "da-DK",
  "fi-FI",
  "el-GR",
  "hu-HU",
  "id-ID",
  "no-NO",
  "sk-SK",
  "sv-SE",
  "lt-LT",
  "lv-LV",
  "ms-MY",
  "af-ZA",
  "ar-SA",
  "az-AZ",
  "bs-BA",
  "cy-GB",
  "fa-IR",
  "fil-PH",
  "gl-ES",
  "he-IL",
  "hr-HR",
  "hy-AM",
  "is-IS",
  "kk-KZ",
  "kn-IN",
  "mk-MK",
  "mr-IN",
  "ne-NP",
  "sl-SI",
  "sr-RS",
  "sw-KE",
  "ta-IN",
  "ur-IN",
  "yue-CN",
  "uk-UA",
  "multi",
] as const;

// ============================================================================
// LANGUAGE MAPPING
// ============================================================================

/**
 * Mapping between URL locales and full language codes
 * URL locale (2 chars) → Full language code (5 chars)
 */
export const LOCALE_TO_LANGUAGE_MAP: Record<string, (typeof DEFAULT_LANGUAGES)[number]> = {
  fr: "fr-FR",
  en: "en-US",
  de: "de-DE",
  es: "es-ES",
  it: "it-IT",
  pt: "pt-PT",
  ja: "ja-JP",
  zh: "zh-CN",
  ru: "ru-RU",
  ko: "ko-KR",
  nl: "nl-NL",
  pl: "pl-PL",
  tr: "tr-TR",
  ar: "ar-SA",
  hi: "hi-IN",
  th: "th-TH",
  vi: "vi-VN",
  sv: "sv-SE",
  da: "da-DK",
  fi: "fi-FI",
  no: "no-NO",
  he: "he-IL",
  fa: "fa-IR",
  uk: "uk-UA",
} as const;

/**
 * Reverse mapping: Full language code → URL locale
 * Only includes languages that have URL locale mappings
 */
export const LANGUAGE_TO_LOCALE_MAP: Partial<Record<DefaultLanguageType, string>> = {
  "fr-FR": "fr",
  "fr-CA": "fr",
  "en-US": "en",
  "en-GB": "en",
  "en-AU": "en",
  "en-NZ": "en",
  "en-IN": "en",
  "de-DE": "de",
  "es-ES": "es",
  "es-419": "es",
  "it-IT": "it",
  "pt-PT": "pt",
  "pt-BR": "pt",
  "ja-JP": "ja",
  "zh-CN": "zh",
  "ru-RU": "ru",
  "ko-KR": "ko",
  "nl-NL": "nl",
  "nl-BE": "nl",
  "pl-PL": "pl",
  "tr-TR": "tr",
  "ar-SA": "ar",
  "hi-IN": "hi",
  "th-TH": "th",
  "vi-VN": "vi",
  "sv-SE": "sv",
  "da-DK": "da",
  "fi-FI": "fi",
  "no-NO": "no",
  "he-IL": "he",
  "fa-IR": "fa",
  "uk-UA": "uk",
} as const;

/**
 * Supported URL locales (extracted from mapping keys)
 */
export const SUPPORTED_LOCALES = Object.keys(LOCALE_TO_LANGUAGE_MAP) as Array<keyof typeof LOCALE_TO_LANGUAGE_MAP>;
export type SupportedLocaleType = (typeof SUPPORTED_LOCALES)[number];

export const SUPPORTED_AGENT_LANGUAGES = ["en-US", "fr-FR"] as const;
export const DEFAULT_AGENT_LANGUAGE = "fr-FR" as const;
export type SupportedAgentLanguage = (typeof SUPPORTED_AGENT_LANGUAGES)[number];
export type DefaultLanguageType = (typeof DEFAULT_LANGUAGES)[number];
